import vuex from 'vuex'
import Vue from 'vue'
Vue.use(vuex)

const navegacion = {
    namespaced: true,
    state: {
        
    },
    actions: {
        set_parametro({ commit }, payload) {
            commit('SET_PARAMETRO', payload)
        }
    },
    mutations: {
        SET_PARAMETRO(state, parametro) {
            let lista = localStorage.parametros;            
            if (lista !== undefined) {
                lista=JSON.parse(unescape(lista));
                let temp = lista.filter(p => p.nombre === parametro.nombre)[0];
                if (temp !== undefined) {
                    temp.valor = parametro.valor;
                }
                else {
                    lista.push({ nombre: parametro.nombre, valor: parametro.valor });
                }
                localStorage.setItem('parametros', JSON.stringify(lista));
            }
            else {
               lista = [];
                lista.push( { "nombre": parametro.nombre, "valor": parametro.valor });                
                localStorage.setItem('parametros', JSON.stringify(lista));
            }
        }
    }
}

export default navegacion;
